<!-- DISCOUNT & APPLIEDCOUPONCODE -->
@if(_calculatedPrice?.discountincvat && _calculatedPrice?.discountincvat !== 0 || _calculatedPrice?.appliedcouponcode){
  @if (!useRecipefirstStyle) {
    <div class="flex flex-row justify-between">
      <small class="capitalize">{{'common.discount' | translate}} @if(_calculatedPrice?.appliedcouponcode){ ({{_calculatedPrice?.appliedcouponcode}}) }</small>
      @if(_calculatedPrice?.discountincvat && _calculatedPrice?.discountincvat !== 0){
      <small>{{_calculatedPrice?.discountincvat * -1 |currency: 'EUR':'symbol':'.2-2':'nl'}}</small>
      }
    </div>
  } @else {
    <div class="flex flex-row justify-between text-[#FF8A3D] text-[1rem] mb-[0.25rem]">
      <span>{{'common.discount' | translate}} @if(_calculatedPrice?.appliedcouponcode){ ({{_calculatedPrice?.appliedcouponcode}}) }</span>
      @if(_calculatedPrice?.discountincvat && _calculatedPrice?.discountincvat !== 0){
        <span>{{_calculatedPrice?.discountincvat * -1 |currency: 'EUR':'symbol':'.2-2':'nl'}}</span>
      }
    </div>
  }
}

<!-- COMPENSATION VALUE -->
@if(_calculatedPrice?.totalcompensated > 0){
<div class="flex flex-row justify-between">
  <span><small>{{'common.compensation' | translate}}</small></span>
  <span><small>{{_calculatedPrice?.totalcompensated * -1 |currency: 'EUR':'symbol':'.2-2':'nl'}}</small></span>
</div>
}

@if(!useRecipefirstStyle) {
  <!-- SUBTOTAL -->
  <div class="pt-[5px] flex flex-row justify-between">
    <span [ngClass]="{ 'font-bold': !_showShipping}">{{'common.subtotal' | translate}}</span>

    <span [ngClass]="{ 'font-bold': !_showShipping}">
      @if(_calculatedPrice){
      {{_calculatedPrice?.priceincvat - _calculatedPrice?.shippingcost |currency: 'EUR':'symbol':'.2-2':'nl'}}
      }@else{
      {{0 |currency: 'EUR':'symbol':'.2-2':'nl'}}
      }
    </span>
  </div>
  <!-- shippincotsts -->
  @if(_showShipping && _calculatedPrice?.shippingcost !== null){
    <div class="flex flex-row justify-between">
      <div class="flex flex-row">
        <small>{{ (_shippingmethod === "PICKUP_STORE"? 'order.pickup_contribution' : 'order.shipping') | translate}}</small>
      </div>
      @if(_calculatedPrice?.shippingcost !== 0){
      <span>{{_calculatedPrice?.shippingcost |currency: 'EUR':'symbol':'.2-2':'nl'}}</span>
      }@else {
      <span class="font-bold">{{'common.free' |translate}}</span>
      }

    </div>
  }
  @if(_showShipping && _calculatedPrice?.shippingcost === null){
    <div class="flex flex-row justify-between">
      <div class="flex flex-row">
        <small>{{ (_shippingmethod === "PICKUP_STORE"? 'order.pickup_contribution' : 'order.shipping') | translate}}</small>
      </div>
      <small class="italic">{{'orderflow.deliveryinfo.shipping_will_be_calculated' |translate}}</small>
    </div>
  }
} @else {
  <!-- SUBTOTAL -->
  <div class="flex flex-row justify-between mb-[0.25rem]">
    <span class="text-[1rem]">{{'common.subtotal' | translate}}</span>
    <span class="text-[1rem]">
      @if(_calculatedPrice){
      {{_calculatedPrice?.priceincvat - _calculatedPrice?.shippingcost |currency: 'EUR':'symbol':'.2-2':'nl'}}
      }@else{
      {{0 |currency: 'EUR':'symbol':'.2-2':'nl'}}
      }
    </span>
  </div>
  <!-- shippincotsts -->
  @if(_showShipping && useRecipefirstStyle && !_hasDeliveryDate){
    <div class="flex flex-row justify-between">
      <span class="text-[1rem]">{{ (_shippingmethod === "PICKUP_STORE"? 'order.pickup_contribution' : 'order.shipping') | translate}}</span>
      <span class="text-[1rem] italic">{{'orderflow.deliveryinfo.shipping_will_be_calculated' |translate}}</span>
    </div>
  }
  @if(_showShipping && useRecipefirstStyle && _hasDeliveryDate && _calculatedPrice?.shippingcost === null){
    <div class="flex flex-row justify-between">
      <span class="text-[1rem]">{{ (_shippingmethod === "PICKUP_STORE"? 'order.pickup_contribution' : 'order.shipping') | translate}}</span>
      <span class="text-[1rem] italic">{{'orderflow.deliveryinfo.shipping_will_be_calculated' |translate}}</span>
    </div>
  }
  @if(_showShipping && _calculatedPrice?.shippingcost !== null && _hasDeliveryDate){
    <div class="flex flex-row justify-between">
      <span class="text-[1rem]">{{ (_shippingmethod === "PICKUP_STORE"? 'order.pickup_contribution' : 'order.shipping') | translate}}</span>
      @if(_calculatedPrice?.shippingcost !== 0){
      <span class="text-[1rem]">{{_calculatedPrice?.shippingcost |currency: 'EUR':'symbol':'.2-2':'nl'}}</span>
      }@else {
      <span class="text-[1rem]">{{'common.free' |translate}}</span>
      }
    </div>
  }
}

<hr class="opacity-10 my-3 border border-black" />

<!-- TOTAL -->
@if(_showShipping){
  <div [ngClass]="useRecipefirstStyle ? 'text-[1.25rem] flex flex-row justify-between' : 'text-xl flex flex-row justify-between'">
    <strong>{{'common.total' | translate}}</strong>
    <div class="flex flex-row justify-end">
      <strong>
        @if(_calculatedPrice){ {{_calculatedPrice?.priceincvat |currency: 'EUR':'symbol':'.2-2':'nl'}} }
        @else{ {{0 |currency: 'EUR':'symbol':'.2-2':'nl'}}}
      </strong>
    </div>
  </div>
}

<!-- MOV -->
@if(_calculatedPrice?.basketmovvalue && showMov){
<div class="flex flex-row flex-wrap justify-between" id="baseketmov">
  <small class="fst-italic small mt-1 whitespace-nowrap pe-0">{{'mov.you_can_already_order_from' |translate }} {{_calculatedPrice?.basketmovvalue |currency:
    'EUR':'symbol':'.2-2':'nl'}}</small>
  @if(!_calculatedPrice?.basketmovreached && _calculatedPrice?.priceincvat !== 0){
  <small class="fst-italic small mt-1 pe-0">
    <i class="bi bi-exclamation-triangle-fill"></i>
    {{'mov.you_did_not_reach_mov_yet' |translate : { value: _calculatedPrice?.basketmovvalue - _calculatedPrice?.priceincvat |currency: 'EUR':'symbol':'.2-2':'nl'} }}
  </small>
  }
</div>
}
@if (_countrycode) {
<div class="flex flex-row flex-wrap justify-between">
  <small>
    <app-movlabel [calculatedPrice]="_calculatedPrice" [countrycode]="_countrycode" [showShipping]="_showShipping" [shippingmethod]="_shippingmethod">
    </app-movlabel>
  </small>
</div>
}